import React from 'react';
import produktion from './assets/Produktion.png';
import './Produktion.css'

function Produktion() {
  return (
<div className="angebot">
  <h2>Musikproduktion</h2>
  <p><strong>Du hast Songs in der Schublade, die noch nicht ganz "fertig" sind?</strong></p>

  <div className="angebot-columns">
    <img className="responsive-img" src={produktion} alt="Studio" />

    <div className="angebot-text">
      <p>Angebot von <i>Regentänzer</i>:</p>
      <ul>
        <li>Elektronische Musikproduktion, Arrangement, Sounddesign</li>
        <li>Mixing, Mastering</li>
        <li>Vocal-Aufnahmen im Home-Studio</li>
        <li>Feedback und Ideen zu deinen Songs</li>
        <li>Release auf allen gängigen Plattformen</li>
      </ul>

      <p>Von der Musikrichtung her gerne in Richtung Elektronisch/Alt-Pop/Indie. Falls du Interesse hast, schick gerne ein Demo und einen Referenzsong rüber, den Rest dann lieber in Person!</p>
    </div>
  </div>
</div>
  );
}

export default Produktion;